// extracted by mini-css-extract-plugin
export default {"content":"PkXse0uQ3j9dXkpolaTQ","buttons":"l4G5DFlBK32n7f3eKMYL"};